/* Thread Mug wishlist — self-contained (2026-10-02).
   Storage: localStorage "tm:wishlist" = [{id, handle}], newest first, max 50.
   Hearts: [data-tm-wish][data-id][data-handle]. Header count: [data-tm-wish-count].
   Event: document "tm:wishlist:change" {detail: {items, count}}. API: window.TMWishlist. */
(function () {
  'use strict';
  if (window.TMWishlist) return;

  var KEY = 'tm:wishlist';
  var MAX = 50;
  var memory = [];
  var toastedMemory = false;

  function rootUrl() {
    var r = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    return r.charAt(r.length - 1) === '/' ? r : r + '/';
  }
  function pageUrl() { return rootUrl() + 'pages/wishlist'; }

  function clean(list) {
    var seen = {};
    var out = [];
    (Array.isArray(list) ? list : []).forEach(function (it) {
      if (!it || it.id == null || it.id === '') return;
      var id = String(it.id);
      if (seen[id]) return;
      seen[id] = true;
      out.push({ id: id, handle: String(it.handle || '') });
    });
    return out.slice(0, MAX);
  }

  function read() {
    try {
      var raw = window.localStorage.getItem(KEY);
      memory = clean(raw ? JSON.parse(raw) : []);
    } catch (e) { /* storage blocked: keep in-memory list */ }
    return memory.slice();
  }

  function write(list) {
    memory = clean(list);
    try { window.localStorage.setItem(KEY, JSON.stringify(memory)); } catch (e) {}
    sync();
    emit();
    return memory.slice();
  }

  function emit() {
    var items = memory.slice();
    try {
      document.dispatchEvent(new CustomEvent('tm:wishlist:change', { detail: { items: items, count: items.length } }));
    } catch (e) {}
  }

  function has(id) {
    id = String(id);
    return read().some(function (it) { return it.id === id; });
  }

  function add(item, index) {
    if (!item || !item.id) return read();
    var list = read().filter(function (it) { return it.id !== String(item.id); });
    var entry = { id: String(item.id), handle: String(item.handle || '') };
    if (typeof index === 'number' && index >= 0) list.splice(Math.min(index, list.length), 0, entry);
    else list.unshift(entry);
    return write(list);
  }

  function remove(id) {
    id = String(id);
    return write(read().filter(function (it) { return it.id !== id; }));
  }

  /* ---------- UI sync ---------- */
  function sync() {
    var ids = {};
    memory.forEach(function (it) { ids[it.id] = true; });
    var btns = document.querySelectorAll('[data-tm-wish]');
    for (var i = 0; i < btns.length; i++) {
      var b = btns[i];
      var saved = !!ids[String(b.getAttribute('data-id') || '')];
      b.classList.toggle('is-saved', saved);
      b.setAttribute('aria-pressed', saved ? 'true' : 'false');
      var label = saved ? 'Saved' : 'Save to wishlist';
      if (b.closest('.tm-wl')) label = saved ? 'Remove from wishlist' : 'Save to wishlist';
      b.setAttribute('aria-label', label);
      b.setAttribute('title', label);
    }
    var n = memory.length;
    var counts = document.querySelectorAll('[data-tm-wish-count], [data-count-wishlist]');
    for (var j = 0; j < counts.length; j++) {
      counts[j].textContent = String(n);
      counts[j].classList.toggle('t4s-op-0', n === 0);
    }
    var links = document.querySelectorAll('a[data-link-wishlist]');
    for (var k = 0; k < links.length; k++) links[k].setAttribute('href', pageUrl());
  }

  /* ---------- Toast ---------- */
  var toastEl = null;
  var toastTimer = null;
  function toast(text, actionLabel, action) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'tm-wish-toast';
      toastEl.setAttribute('role', 'status');
      toastEl.setAttribute('aria-live', 'polite');
      document.body.appendChild(toastEl);
    }
    toastEl.innerHTML = '';
    var span = document.createElement('span');
    span.textContent = text;
    toastEl.appendChild(span);
    if (actionLabel) {
      var sep = document.createElement('span');
      sep.className = 'tm-wish-toast__sep';
      sep.textContent = '·';
      toastEl.appendChild(sep);
      var el;
      if (typeof action === 'string') {
        el = document.createElement('a');
        el.href = action;
      } else {
        el = document.createElement('button');
        el.type = 'button';
        el.addEventListener('click', function () {
          hideToast();
          action();
        });
      }
      el.textContent = actionLabel;
      toastEl.appendChild(el);
    }
    /* force reflow so the transition runs */
    void toastEl.offsetWidth;
    toastEl.classList.add('is-visible');
    window.clearTimeout(toastTimer);
    toastTimer = window.setTimeout(hideToast, 3000);
  }
  function hideToast() {
    if (toastEl) toastEl.classList.remove('is-visible');
  }

  function firstSaveThisSession() {
    try {
      if (window.sessionStorage.getItem('tm:wishlist:toasted')) return false;
      window.sessionStorage.setItem('tm:wishlist:toasted', '1');
      return true;
    } catch (e) {
      if (toastedMemory) return false;
      toastedMemory = true;
      return true;
    }
  }

  function pop(btn) {
    btn.classList.remove('is-pop');
    void btn.offsetWidth;
    btn.classList.add('is-pop');
    window.setTimeout(function () { btn.classList.remove('is-pop'); }, 450);
  }

  /* ---------- Click handling (capture phase so card links never fire) ---------- */
  document.addEventListener('click', function (event) {
    var btn = event.target && event.target.closest ? event.target.closest('[data-tm-wish]') : null;
    if (!btn) return;
    event.preventDefault();
    event.stopPropagation();
    var id = btn.getAttribute('data-id');
    if (!id) return;
    var handle = btn.getAttribute('data-handle') || '';
    if (has(id)) {
      var before = read();
      var index = -1;
      before.forEach(function (it, i) { if (it.id === String(id)) index = i; });
      var onPage = !!btn.closest('.tm-wl');
      remove(id);
      if (onPage) {
        toast('Removed', 'Undo', function () { add({ id: id, handle: handle }, index); });
      }
    } else {
      add({ id: id, handle: handle });
      pop(btn);
      if (firstSaveThisSession()) toast('Saved to your wishlist', 'View', pageUrl());
    }
  }, true);

  /* Header / mobile-toolbar wishlist links always open our page, even if the theme rewrites their href. */
  document.addEventListener('click', function (event) {
    var link = event.target && event.target.closest ? event.target.closest('a[data-link-wishlist], a[data-tm-wish-link]') : null;
    if (!link || event.metaKey || event.ctrlKey || event.shiftKey || event.button > 0) return;
    event.preventDefault();
    event.stopPropagation();
    window.location.href = pageUrl();
  }, true);

  /* Keep the theme's count badges on our number if the theme repaints them. */
  var countGuard = null;
  function guardCounts() {
    if (countGuard || typeof MutationObserver === 'undefined') return;
    var els = document.querySelectorAll('[data-count-wishlist], [data-tm-wish-count]');
    if (!els.length) return;
    countGuard = new MutationObserver(function () {
      var n = String(memory.length);
      for (var i = 0; i < els.length; i++) {
        if (els[i].textContent !== n) {
          els[i].textContent = n;
          els[i].classList.toggle('t4s-op-0', n === '0');
        }
      }
    });
    for (var i = 0; i < els.length; i++) countGuard.observe(els[i], { childList: true, characterData: true, subtree: true });
  }

  /* Product page: place the heart beside the title (template rendered by layout/theme.liquid). */
  function placePdpHeart() {
    var tpl = document.querySelector('template[data-tm-wish-pdp]');
    var title = document.querySelector('.tm-pdp__title');
    if (!tpl || !title || !tpl.content || title.parentNode.classList.contains('tm-wish-titlerow')) return;
    var row = document.createElement('div');
    row.className = 'tm-wish-titlerow';
    title.parentNode.insertBefore(row, title);
    row.appendChild(title);
    row.appendChild(tpl.content.cloneNode(true));
  }

  /* other tabs */
  window.addEventListener('storage', function (e) {
    if (e.key !== KEY) return;
    read();
    sync();
    emit();
  });

  window.TMWishlist = {
    key: KEY,
    list: read,
    has: has,
    add: add,
    remove: remove,
    count: function () { return read().length; },
    sync: function () { read(); sync(); },
    toast: toast,
    pageUrl: pageUrl
  };

  /* ---------- Wishlist page renderer ----------
     Cards come from the server (sections/tm-wish-card renders snippets/tm-product-card,
     the same card as the collection page) via the Section Rendering API. */
  var SW_CUSTOM = {
    crunchberry: '#ef4a81', butter: '#f5e1a4', bay: '#94a596', blossom: '#f8bed6',
    'blue jean': '#647692', 'blue spruce': '#3e5d58', chili: '#893c47', graphite: '#1d252d',
    ivory: '#e7ceb5', moss: '#22372b', orchid: '#c7b2de', pepper: '#4e4b48', watermelon: '#f4364c',
    espresso: '#553c36', 'light green': '#5c7f71', grey: '#716e6a', gray: '#716e6a', crimson: '#a4123f',
    chambray: '#bdd6e6', 'chalky mint': '#5cb8b2', terracotta: '#e3775e', denim: '#425563',
    navy: '#0c2340', black: '#25282a', white: '#ffffff'
  };
  var SW_FAMILY = [
    [['burgundy', 'maroon', 'wine'], '#800020'], [['pink', 'rose', 'fuchsia', 'magenta'], '#e83e8c'],
    [['purple', 'violet', 'plum', 'lilac', 'lavender'], '#8e6bbf'], [['blue', 'azure', 'cyan', 'aqua', 'teal', 'turquoise'], '#3f7ea3'],
    [['green', 'mint', 'olive', 'sage', 'lime', 'forest'], '#5c7f71'], [['yellow', 'gold', 'mustard'], '#d7b43a'],
    [['orange', 'coral', 'peach', 'apricot'], '#e0784d'], [['red', 'scarlet', 'ruby'], '#b52b35'],
    [['brown', 'tan', 'beige', 'camel', 'khaki'], '#9a7653'], [['black', 'charcoal'], '#25282a'],
    [['white', 'snow', 'cream'], '#f7f7f2'], [['gray', 'grey', 'silver'], '#716e6a']
  ];
  /* same resolution as the collection page swatch script (server colour wins) */
  function resolveSwatches(scope) {
    if (typeof window.TMRescanSwatches === 'function') { window.TMRescanSwatches(scope); return; }
    var probe = null;
    Array.prototype.forEach.call(scope.querySelectorAll('[data-tm-color-value]:not([data-tm-swatch-resolved])'), function (btn) {
      var cur = btn.style.getPropertyValue('--tm-swatch');
      if (cur && cur.trim()) return;
      var n = String(btn.getAttribute('data-tm-color-value') || '').toLowerCase().trim()
        .replace(/[\/&(].*$/, '').trim().replace(/[‐-―−_-]+/g, ' ')
        .replace(/[.,'"]+/g, '').replace(/\s+/g, ' ').trim();
      if (!n) return;
      var color = SW_CUSTOM[n] || '';
      if (!color) {
        if (!probe) { probe = document.createElement('span'); probe.style.display = 'none'; document.body.appendChild(probe); }
        [n, n.replace(/\s+/g, ''), n.replace(/\s+/g, '-')].some(function (c) {
          probe.style.backgroundColor = '';
          probe.style.backgroundColor = c;
          if (probe.style.backgroundColor) { color = getComputedStyle(probe).backgroundColor; return true; }
          return false;
        });
      }
      if (!color) {
        SW_FAMILY.some(function (f) {
          return f[0].some(function (k) { if (n.indexOf(k) !== -1) { color = f[1]; return true; } return false; });
        });
      }
      if (color) {
        btn.style.setProperty('--tm-swatch', color);
        btn.setAttribute('data-tm-swatch-resolved', '1');
      }
    });
    if (probe && probe.parentNode) probe.parentNode.removeChild(probe);
  }

  function initPage(page) {
    var grid = page.querySelector('[data-tm-wl-grid]');
    var loading = page.querySelector('[data-tm-wl-loading]');
    var empty = page.querySelector('[data-tm-wl-empty]');
    var countEl = page.querySelector('[data-tm-wl-count]');
    var cards = {};
    var removeTimers = {};

    function render() {
      var list = read();
      var shown = 0;
      var ids = {};
      list.forEach(function (it) {
        ids[it.id] = true;
        var c = cards[it.id];
        if (!c) return;
        if (removeTimers[it.id]) { window.clearTimeout(removeTimers[it.id]); delete removeTimers[it.id]; }
        c.classList.remove('is-removing');
        grid.appendChild(c);
        shown++;
      });
      Object.keys(cards).forEach(function (id) {
        var c = cards[id];
        if (ids[id] || !c.parentNode || removeTimers[id]) return;
        c.classList.add('is-removing');
        removeTimers[id] = window.setTimeout(function () {
          delete removeTimers[id];
          if (c.parentNode && c.classList.contains('is-removing')) c.parentNode.removeChild(c);
          if (!grid.children.length) { empty.hidden = false; grid.hidden = true; }
        }, 260);
      });
      if (countEl) countEl.textContent = shown ? '(' + shown + ')' : '';
      if (shown) { empty.hidden = true; grid.hidden = false; }
      else if (!grid.querySelector('.is-removing')) { empty.hidden = false; grid.hidden = true; }
      sync();
    }

    var items = read();
    if (!items.length) {
      loading.hidden = true;
      render();
      document.addEventListener('tm:wishlist:change', render);
      return;
    }

    Promise.all(items.map(function (it) {
      if (!it.handle) return Promise.resolve({ it: it, card: null });
      var url = rootUrl() + 'products/' + encodeURIComponent(it.handle) + '?section_id=tm-wish-card';
      return fetch(url, { credentials: 'same-origin' })
        .then(function (res) {
          if (res.status === 404) return { it: it, card: null };
          if (!res.ok) return { it: it, card: undefined };
          return res.text().then(function (html) {
            var tpl = document.createElement('template');
            tpl.innerHTML = html;
            var wrap = tpl.content.querySelector('[data-tm-wish-card]');
            if (!wrap || wrap.getAttribute('data-available') !== 'true') return { it: it, card: null };
            var c = wrap.querySelector('.tm-coll__card');
            if (c) c.setAttribute('data-tm-wl-id', it.id);
            return { it: it, card: c || null };
          });
        })
        .catch(function () { return { it: it, card: undefined }; });
    })).then(function (results) {
      var gone = [];
      results.forEach(function (r) {
        if (r.card === undefined) return; /* network hiccup: keep the item, just don't show it now */
        if (!r.card) { gone.push(r.it.id); return; }
        cards[r.it.id] = r.card;
      });
      loading.hidden = true;
      if (gone.length) write(read().filter(function (it) { return gone.indexOf(it.id) === -1; }));
      render();
      resolveSwatches(grid);
      document.addEventListener('tm:wishlist:change', render);
    });
  }

  function boot() {
    read();
    try { placePdpHeart(); } catch (e) {}
    sync();
    guardCounts();
    var page = document.querySelector('[data-tm-wl-page]');
    if (page) initPage(page);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  /* the theme may repaint header counts after load */
  window.addEventListener('load', function () { window.setTimeout(sync, 300); });
})();
